import * as React from 'react';

import BgDesktop from '@/assets/images/login-bg-desktop.webp';
import BgMobile from '@/assets/images/login-bg-mobile.webp';
import ImageDesktop from '@/assets/images/login-image-desktop.png';
import ImageMobile from '@/assets/images/login-image-mobile.png';
import BhanzuLCLogo from '@/assets/logos/bhanzu-lc.svg';
import BhanzuLogo from '@/assets/logos/bhanzu-logo.svg';
import { env } from '@/config/env';

type LayoutProps = {
  children: React.ReactNode;
};

export function AuthLayout({ children }: Readonly<LayoutProps>) {
  return (
    <div className="min-h-screen h-auto px-2 md:px-8 relative">
      {/* Mobile Background */}
      <div
        className="absolute inset-0 bg-cover bg-no-repeat bg-center md:hidden"
        style={{ backgroundImage: `url(${BgMobile})` }}
      />

      {/* Desktop Background */}
      <div
        className="absolute inset-0 bg-cover bg-no-repeat bg-center hidden md:block"
        style={{ backgroundImage: `url(${BgDesktop})` }}
      />

      {/* Content */}
      <div
        className="relative z-(--z-nominal) max-w-screen-xl mx-auto"
        id="auth-layout-content"
      >
        {/* Bhanzu Logo */}
        <div className="flex justify-start mb-4 sm:mb-0">
          <img
            src={env.IS_OFFLINE ? BhanzuLCLogo : BhanzuLogo}
            alt="Bhanzu"
            className="w-32 h-auto "
          />
        </div>

        {/* Main Content Grid */}
        <div className="flex flex-col md:flex-row">
          {/* Left Side - Title and Image */}
          <div className="w-full text-left hidden md:block">
            {/* Mobile Divider */}
            <div
              className="
            block md:hidden 
            border-t border-dashed border-gray-400 
            w-full
          "
            />

            {/* Title and Image Content */}
            <div>
              {/* Title */}
              <div className="mt-4">
                <h1
                  className="
                text-4xl 
                leading-12 
                font-bold 
                capitalize 
                text-[#413930]
                text-left
              "
                >
                  Personalized Learning <br /> Dashboard
                </h1>
              </div>

              {/* Images */}
              <div>
                {/* Desktop Image */}
                <div className="hidden md:flex">
                  <img
                    src={ImageDesktop}
                    alt="Welcome to Bhanzu"
                    className="w-xl"
                  />
                </div>

                {/* Mobile Image */}
                <div className="flex md:hidden justify-center">
                  <img src={ImageMobile} alt="Welcome to Bhanzu" />
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - Children (Forms) */}
          {children}
        </div>
      </div>
    </div>
  );
}
